import React, { Component } from 'react';
import Header from './components/Header';
import { Route, Switch } from 'react-router-dom';
import Home from './Pages/Home';
import Login from './Pages/Login';
import register from './Pages/Register';
import ChangePass from './Pages/ChangePass';
import Reservation from './Pages/Reservation';
import Admin from './Pages/Admin';
import { connect } from 'react-redux';
import { login, keepLogin } from './redux/Action';
// import Axios from 'axios';
// import { API_URL } from './API_url/API_URL';
import MovieDetail from './components/movieDetails';
import Footer from './components/Footer';
import Cart from './Pages/Cart';
import NotFound from './Pages/NotFound';
import TsHistoryUsers from './Pages/TsHistoryUsers';
import TsHistoryAdmin from './Pages/TsHistoryAdmin';


class App extends Component {
 
  componentDidMount(){
    // let username = localStorage.getItem('username')
    // if(username){
    //   Axios.get(API_URL + `/users?username=${username}`)
    //   .then((res) => {
    //     this.props.login(res.data[0])
    //   })
    // }
    this.props.keepLogin() 
  }
  //supaya ketika direfresh tetap login

  render() {
    
    return (
      <div>
        <Header />
        <Switch>
        <Route path='/' component={Home} exact />
        <Route path='/login' component={Login} />
        <Route path='/movie-detail' component={MovieDetail} />
        <Route path='/register' component={register} />
        <Route path='/change-password' component={ChangePass} />
        <Route path='/reservation' component={Reservation} />
        <Route path='/manage-movies' component={Admin}  />
        <Route path='/cart' component={Cart} />
        <Route path='/ts-history' component={TsHistoryUsers} />
        <Route path='/ts-histories' component={TsHistoryAdmin} />
        <Route path='*' component={NotFound} />
        </Switch>
        <Footer />
      </div>
    );
  } 
}

const mapStatetoProps = ({auth}) => {
  return {
      role: auth.role,
  }
}

export default connect(mapStatetoProps, {login, keepLogin})(App);
